import { ExistingDataInquiry } from '@interhyp/module-existing-data-inquiry';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import '@interhyp/module-existing-data-inquiry/esm/index.css';
import '@interhyp/shared-existing-data-inquiry/esm/index.css';

import { Navigation, NavItems } from '../../navigation/Navigation';

export interface ExistingDataInquiryOverviewWrapperProps {
  currentUserId: string;
  providerId: string;
}

export function ExistingDataInquiryOverviewWrapper({
  currentUserId,
  providerId,
}: ExistingDataInquiryOverviewWrapperProps): JSX.Element {
  const { existingDataInquiryId } = useParams<{ existingDataInquiryId: string }>();

  const navigationItems: NavItems = useMemo(() => {
    return [
      {
        to: `/credit/existing-data-inquiries/${existingDataInquiryId}`,
        translation: 'navigation.existingDataInquiry',
      },
      {
        to: `/credit/existing-data-inquiries/${existingDataInquiryId}/documents`,
        translation: 'navigation.documents',
      },
    ];
  }, [existingDataInquiryId]);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <ExistingDataInquiry
        providerId={providerId}
        currentUserId={currentUserId}
        existingDataInquiryId={existingDataInquiryId}
      />
    </>
  );
}
